import React, { useRef } from "react";
import Button from "../../_components/button/Button";
import "./introduction.css";

const Content = () => {
  return (
    <div className="text-white font-extralight text-lg px-5 z-50 lg:w-3/6 w-full">
      <p className="mb-10">
        Setting the standard for over 20 years, we knew that it would take
        something extraordinary to push the boundaries of performance even
        further. So every aspect of the AVM 90's design was scrutinized, every
        component carefully considered and reconsidered. With AVM 90, it's not
        about a single component or single feature; it is about the totality of
        our design—everything working together in perfect harmony to deliver a
        performance that genuinely transcends the listening experience.
      </p>
      <p className="mb-10">
        We start with an oversized high-efficiency toroidal power supply,
        isolating the high power signals from the sensitive audio pathway. The
        critical conversion from digital to analog utilizes the highest
        performance ESS Sabre DACs for all 19 channels of processing. Compared
        to traditional voltage source circuits, these current source designs are
        a dramatic step forward in performance and complexity compared to
        conventional voltage source circuits.
      </p>
      <p className="mb-10">
        But reference DACs aren't enough; we know the entire signal path needed
        to be upgraded to match. Ultra-low noise, ultra-low distortion high
        output op-amps were carefully selected, and superior 0.1% high precision
        resistors were used to reduce distortion further and ensure gain
        consistency between channels. The best linear regulators were selected
        to provide low noise reference supplies to the premium audio converters
        and back-end circuits. As the complexity and density increased, it
        became necessary to implement premium high-layer count circuit boards
        with additional isolating ground planes. This allowed our engineers the
        freedom to ensure every channel has a unique, low cross-talk and
        pristine signal path.
      </p>
      <p className="mb-10">
        We didn't stop there. To ensure a bit-perfect experience, we've included
        the most advanced implementation of our award-winning ARC: Genesis Room
        Correction technology and an all-new DSP platform featuring a 32-bit
        floating-point audio data path with a 64-bit floating-point computation
        and double-precision filter states. With ARC: Genesis, professional
        calibration of your system can be achieved with the click of a button
        while still offering advanced functionality to further refine the sound
        to your personal taste.
      </p>
      <p className="mb-10">
        After experiencing the AVM 90 for the first time, we knew that we had
        exceeded every expectation. Rendering audio with such vividness, such
        stunning clarity, you'll want to reach out and touch it.
      </p>
      {/* <img
        src="https://cdn.pmlsound.com/anthem/avm90/images/anthem_design_team_.svg"
        alt="Anthem Design Team"
        className="mt-10 w-2/3 md:w-2/6"
      /> */}
    </div>
  );
};

const Introduction = () => {
  const [textArray, setTextArray] = React.useState([]);
  const [showcontent, setShowContent] = React.useState(false);

  const text = `Introducing AVM 90. Our most sophisticated audio-video processor. Every aspect of its design was scrutinized, every component carefully considered and reconsidered. It's the culmination of everything we know and unlike anything you've ever heard. Meet our embodiment of excellence, meet AVM 90.`;

  React.useEffect(() => {
    function handleScroll() {
      const elementBoundaries = document
        .querySelector(".introduction p")
        .getBoundingClientRect();

      let percentage = 0;

      if (elementBoundaries.top - 500 < 0) {
        percentage = Math.abs(
          ((elementBoundaries.top - 500) / elementBoundaries.height) * 100
        );

        percentage = percentage > 100 ? 100 : percentage;
      }

      const textArray = text.split("");

      const numOfWhiteChars = (textArray.length * percentage) / 100;

      const newTextArray = textArray.map((c, i) => (
        <span className={i < numOfWhiteChars ? "text-white" : null}>{c}</span>
      ));

      setTextArray(newTextArray);
    }

    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const introduction_ref = useRef();
  const intro_ext = useRef();
  const executeScroll = () => {
    if (showcontent == true) {
      window.scrollTo(0, introduction_ref.current.offsetTop - 150);
    } else {
      window.scrollTo(
        0,
        introduction_ref.current.offsetTop +
          introduction_ref.current.getBoundingClientRect().height -
          80
      );
    }
  };

  return (
    <section
      className="z-50 relative h-full"
      id="intoduction"
      ref={introduction_ref}
      style={{
        backgroundImage:
          "url('https://cdn.pmlsound.com/anthem/avm90/images/avm-highlight-text-bg.jpeg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute bg-black/80 h-full w-full"></div>
      <div className="max-w-7xl py-12 px-5 md:py-44 lg:py-44 z-50 relative text-center mx-auto">
        <div className="introduction  mb-10">
          <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-6xl text-center mb-16">
            Demand Excellence, <br /> Demand Anthem
          </h1>
          <p className="leading-relaxed text-2xl md:text-3xl lg:text-4xl font-light lg:text-center text-center z-50 text-gray-500 ">
            {textArray.length ? textArray : text}
          </p>
        </div>

        <div id="introduction_ref" ref={introduction_ref}></div>

        {showcontent == false && (
          <Button
            name={
              showcontent
                ? "Show Less"
                : "Learn About Our Pursuit of Audio Excellence"
            }
            extraClass={"animated_shadow"}
            width={"w-6/12"}
            handleClick={() => {
              // window.scrollTo({
              //   left: 0,
              //   top: introduction_ref.current - 40,
              //   behavior: "smooth",
              // });
              setShowContent(showcontent ? false : true);
              executeScroll();
            }}
          />
        )}
      </div>
      {showcontent && (
        <div
          className="bg-no-repeat bg-cover lg:relative py-20 pb-40"
          style={{
            backgroundImage:
              "url('https://www.anthemav.com/images/mrx_avm_mca/new-anthem-graphic-hp.png')",
          }}
        >
          <div ref={intro_ext} id="intro_ext"></div>
          <div className=" text-center  z-50">
            <Button
              name={"Show Less"}
              extraClass={"animated_shadow z-50 relative"}
              width={"w-96"}
              handleClick={() => {
                setShowContent(false);
                executeScroll();
              }}
            />
          </div>
          <div className="max-w-9xl mx-auto flex pt-20  items-center z-50 justify-end ">
            <Content />
          </div>
        </div>
      )}
    </section>
  );
};

export default Introduction;
